import React from 'react';

import { CarModelDetailsSelectOptionProps } from './CarModelDetailsSelectOption.interface';
import { SelectOptionWithSubLabels } from 'app/components/SelectOptionWithSubLabels';

export default function CarModelDetailsSelectOption(
  props: CarModelDetailsSelectOptionProps
) {
  return <SelectOptionWithSubLabels {...props} />;
}
